"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.configure = configure;
exports.checker = checker;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _typeof2 = _interopRequireDefault(require("@babel/runtime/helpers/typeof"));

var _react = require("react");

var _getComponentName = _interopRequireDefault(require("react-utils/getComponentName"));

var _invariant = _interopRequireDefault(require("react-utils/invariant"));

var _reagan = _interopRequireDefault(require("../reagan"));

var _CheckerStore = _interopRequireDefault(require("../CheckerStore"));

var reagan = null;
var initialPageLoad = true;
var checkerHOCsWithErrors = {};
var newRelicErrorReporterTimeout;

function configure(options) {
  if (reagan) {
    (0, _invariant.default)(reagan === null, 'Reagan can only be configured once');
  } // If the first argument quacks like a Bucky instance, explicitly pass it and statsPath.
  // Otherwise, pass the first argument as options wholesale


  if (options && options.send && options.timer && options.timer.stopwatch) {
    throw new Error("Bucky is deprecated and no longer needed for Reagan. Don't pass it to the configure call. And unless you are passing custom Reagan options, you don't need to call configure at all anymore.");
  } else {
    reagan = new _reagan.default(options);
  }
}

function checker() {
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      _ref$checkOnChange = _ref.checkOnChange,
      checkOnChange = _ref$checkOnChange === void 0 ? true : _ref$checkOnChange,
      _ref$selectors = _ref.selectors,
      selectors = _ref$selectors === void 0 ? undefined : _ref$selectors,
      _ref$metricGroup = _ref.metricGroup,
      metricGroup = _ref$metricGroup === void 0 ? undefined : _ref$metricGroup;

  // Note, allowing the checker to be created even if Reagan isn't fully setup
  // (e.g. `selectors` is empty), so that we let higher up code send data on routes
  // that have Reagan misconfigured
  if ((0, _typeof2.default)(selectors) !== 'object') {
    console.error('Reagan Checker requires DOM element selectors be specified');
  }

  if (metricGroup) {
    console.warn('The Reagan Checker metricGroup option is deprecated, use names or paths on your routes instead');
  }

  return function wrapWithChecker(WrappedComponent) {
    var componentName = WrappedComponent.displayName || WrappedComponent.name;

    var ReaganChecker =
    /*#__PURE__*/
    function (_Component) {
      (0, _inherits2.default)(ReaganChecker, _Component);

      function ReaganChecker(props, context) {
        var _this;

        (0, _classCallCheck2.default)(this, ReaganChecker);
        _this = (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(ReaganChecker).call(this, props, context)); // Use context as a dependeny injection mechanism to have once reference
        // to a `checkerStore` per component tree. And keep track of which component
        // is the "highested" checker to ensure only once `reaganCheck()` is called
        // per component tree.

        if (context && context.checkerStore) {
          _this.checkerStore = context.checkerStore;
          _this.isTopMostCheckerComponent = false;
        } else {
          _this.checkerStore = new _CheckerStore.default();
          _this.isTopMostCheckerComponent = true;
        }

        if (reagan && !reagan.checkInProgress && !checkerHOCsWithErrors.hasOwnProperty(componentName)) {
          console.error("[Reagan] Selectors added while no checks in progress. These checks won't be used for SLAs. See http://go/reagan-errors for more information.", (0, _extends2.default)({
            componentName: componentName
          }, selectors));
          checkerHOCsWithErrors[componentName] = true;

          if (window.newrelic) {
            clearTimeout(newRelicErrorReporterTimeout);
            newRelicErrorReporterTimeout = setTimeout(function () {
              window.newrelic.addPageAction('reaganSelectorsNotUsed', {
                componentNames: Object.keys(checkerHOCsWithErrors).join(', ')
              });
            }, 1000);
          }
        }

        _this.checkerStore.addMoreChecks({
          checkOnChange: checkOnChange,
          selectors: selectors
        });

        return _this;
      }

      (0, _createClass2.default)(ReaganChecker, [{
        key: "getChildContext",
        value: function getChildContext() {
          return {
            checkerStore: this.checkerStore
          };
        }
      }, {
        key: "componentWillMount",
        value: function componentWillMount() {
          var location = this.props.location; // Automatically call configure if it hasn't been called (since there are
          // now no required configure arguments)

          if (!reagan) {
            configure();
          }

          if (this.isTopMostCheckerComponent && checkOnChange) {
            var debugHelper = componentName ? " on " + componentName : '';
            (0, _invariant.default)(checkOnChange && location, "A location prop is needed for Reagan to run checks on route changes" + debugHelper + ". Some suggestions...\n  - Are the react-router props (location, route, routes) getting through to the first Checker HOC in the React component chain?\n  - Maybe you want to pass `checkOnChange: false` in the Checker configuration and only want a Reagan check to happen on mount?");
          } // Send the route name to New Relic if they are setup


          this.notifyNewRelicOfRouteName();
        }
      }, {
        key: "componentDidMount",
        value: function componentDidMount() {
          // Only ever call reaganCheck() once per component tree
          if (this.isTopMostCheckerComponent) {
            this.reaganCheck();
          }
        }
      }, {
        key: "componentWillReceiveProps",
        value: function componentWillReceiveProps(nextProps) {
          var location = this.props.location; // Note, CheckerStore will ensure that all checker HOCs in the component tree will agree on
          // `checkOnChange`. So it is OK to only call `regeanCheck()` from the topmost checker

          if (this.isTopMostCheckerComponent && checkOnChange && nextProps.location !== location) {
            this.reaganCheck(false);
          }
        }
      }, {
        key: "componentWillUpdate",
        value: function componentWillUpdate() {
          this.notifyNewRelicOfRouteName();
        }
      }, {
        key: "componentWillUnmount",
        value: function componentWillUnmount() {
          // Remove the checks this component provided
          this.checkerStore.removeExistingChecks(selectors);

          if (this.isTopMostCheckerComponent) {
            reagan.stop();
          }
        }
      }, {
        key: "notifyNewRelicOfRouteName",
        value: function notifyNewRelicOfRouteName() {
          var nameForRoute = this.getNameForRoute();

          if (this.isTopMostCheckerComponent && this.lastRouteName !== nameForRoute) {
            this.lastRouteName = nameForRoute;

            if (window.newrelic && window.newrelic.setCurrentRouteName) {
              window.newrelic.setCurrentRouteName(nameForRoute);
              window.newrelic.setCustomAttribute('route', nameForRoute);
            }
          }
        } // If any of the routes in the nested "route path" have a `name`, use that (the deepest one).
        // Otherwise if there are multiple routes that have a `path`, join them all in to a single name `path1/path2/path3`

      }, {
        key: "getNameForRoute",
        value: function getNameForRoute() {
          // The checker HOC passes along a setCustomRouteName prop components can use to
          // manually set the route name (and prevent/overwrite any route name autodetection)
          if (this.checkerStore.hasCustomRouteName()) {
            return this.checkerStore.getCustomRouteName();
          }

          var match = this.props.match;
          var _this$props = this.props,
              route = _this$props.route,
              routes = _this$props.routes; // Support for react-router 0.13.2 (v2 internally)

          if (!routes && this.context && this.context.router && this.context.router.getCurrentRoutes) {
            routes = this.context.router.getCurrentRoutes();
            route = routes[routes.length - 1];
          }

          if (routes) {
            // Join the name/path of whole "route path" together
            var routeNames = routes.map(function (currRoute) {
              return currRoute && currRoute.name;
            }).filter(function (str) {
              return !!str;
            });
            var routePathTokens = routes.map(function (currRoute) {
              return currRoute && currRoute.path;
            }).filter(function (str) {
              return str;
            });
            var cleanRoutePathTokens = routePathTokens.filter(function (str) {
              return str !== '/';
            }).map(function (str) {
              return str.replace(/^\/?|\/?$/, '');
            });

            if (routeNames.length > 0) {
              return routeNames[routeNames.length - 1];
            } else if (cleanRoutePathTokens.length > 0) {
              return cleanRoutePathTokens.join('/');
            } else {
              return routePathTokens.join('/');
            }
          } else if (route) {
            return route.name || route.path;
          } // Support for react-router-dom 4 (v4 internally)


          if (match && match.path) {
            var _routePathTokens = match.path.split('/').filter(function (str) {
              return !!str;
            }).join('/');

            if (_routePathTokens.length > 0) {
              return _routePathTokens;
            }
          }

          return 'unknown-route';
        }
      }, {
        key: "reaganCheck",
        value: function reaganCheck() {
          var _this2 = this;

          var immediate = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
          var options = {
            startTimerOnPageLoad: initialPageLoad
          }; // The first time reaganCheck is ever called is a page load, all others are
          // route changes (requires that we only ever call reaganCheck once per component tree)

          initialPageLoad = false;

          var check = function check() {
            var nameForRoute = _this2.getNameForRoute();

            var checkName = nameForRoute || 'unknown-route';
            reagan.check(checkName, _this2.checkerStore.getCombinedSelectors(), options);
          }; // Only ever allow a single Reagan check to be going at a time. If a user
          // leaves a route before the check finishes, we stop it before starting another


          reagan.stop();

          if (this.reaganCheckTimeout) {
            clearTimeout(this.reaganCheckTimeout);
          }

          if (immediate) {
            check();
          } else {
            this.reaganCheckTimeout = setTimeout(check, 0);
          }
        }
      }, {
        key: "render",
        value: function render() {
          return (0, _react.createElement)(WrappedComponent, (0, _extends2.default)({}, this.props, {
            setCustomRouteName: this.checkerStore.setCustomRouteName.bind(this.checkerStore)
          }));
        }
      }]);
      return ReaganChecker;
    }(_react.Component);

    ReaganChecker.WrappedComponent = WrappedComponent;
    ReaganChecker.displayName = "Reagan(" + (0, _getComponentName.default)(WrappedComponent) + ")";

    var routeType = _react.PropTypes.oneOfType([_react.PropTypes.object, _react.PropTypes.element]);

    ReaganChecker.propTypes = {
      location: _react.PropTypes.object,
      match: _react.PropTypes.object,
      route: routeType,
      routes: _react.PropTypes.oneOfType([routeType, _react.PropTypes.arrayOf(routeType)])
    };
    ReaganChecker.childContextTypes = {
      checkerStore: _react.PropTypes.object
    };
    ReaganChecker.contextTypes = {
      checkerStore: _react.PropTypes.object,
      router: _react.PropTypes.object
    };
    return ReaganChecker;
  };
}